// File: frontend/src/components/LoadingSpinner.js

// --- 1. ИМПОРТЫ ---
import React from 'react';
// Подключаем стили, специфичные для этого компонента.
import './LoadingSpinner.css';

// --- 2. КОМПОНЕНТ ИНДИКАТОРА ЗАГРУЗКИ ---
/**
 * Переиспользуемый компонент для отображения индикатора загрузки.
 * @param {object} props - Свойства компонента.
 * @param {string} [props.message] - Необязательное сообщение для отображения под спиннером.
 */
const LoadingSpinner = ({ message }) => {
    return (
        // Контейнер-оверлей, который центрирует спиннер на странице и затемняет фон.
        <div className="loading-spinner-overlay">
            <div className="loading-spinner-content">
                {/* Сам анимированный спиннер. */}
                <div className="spinner"></div>
                {/* Сообщение отображается только если оно было передано в props. */}
                {message && <p className="loading-message">{message}</p>}
            </div>
        </div>
    );
};

// --- 3. ЭКСПОРТ ---
export default LoadingSpinner;
